(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elite-mat-band"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw-mat-band')) {
  class AwMatBand extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.statusFull = this.querySelector('[data-status-full]');
      this.statusShort = this.querySelector('[data-status-short]');
      this.page = 0;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.onPrev = () => this.step(-1);
      this.onNext = () => this.step(1);
      this.onResize = () => {
        const total = this.pages();
        if (this.page > total - 1) this.page = Math.max(0, total - 1);
        this.apply(false);
      };
      this.onScroll = () => this.syncFromScroll();
      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      window.addEventListener('resize', this.onResize);
      this.viewport?.addEventListener('scroll', this.onScroll, { passive: true });
      this.reveal();
      this.apply(false);
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      window.removeEventListener('resize', this.onResize);
      this.viewport?.removeEventListener('scroll', this.onScroll);
    }

    reduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    perView() {
      return window.matchMedia('(min-width: 990px)').matches ? 3 : 1;
    }

    pages() {
      return Math.max(1, Math.ceil(this.cards.length / this.perView()));
    }

    reveal() {
      const show = () => this.classList.add('is-in');
      this.addEventListener('animationend', (event) => {
        if (event.target.classList?.contains('aw-mats__card')) event.target.classList.add('is-settled');
      });
      if (this.reduced() || (window.Shopify && Shopify.designMode)) {
        this.cards.forEach((card) => card.classList.add('is-settled'));
        show();
        return;
      }
      if (!('IntersectionObserver' in window)) {
        show();
        return;
      }
      this.classList.add('is-armed');
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          show();
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      observer.observe(this);
    }

    step(direction) {
      const total = this.pages();
      this.page = (this.page + direction + total) % total;
      this.apply(true);
    }

    syncFromScroll() {
      if (this.perView() !== 1 || !this.viewport) return;
      const left = this.viewport.scrollLeft;
      let nearest = 0;
      let best = Infinity;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - left);
        if (distance < best) {
          best = distance;
          nearest = index;
        }
      });
      if (nearest !== this.page) {
        this.page = nearest;
        this.writeStatus();
      }
    }

    apply(animate) {
      const per = this.perView();
      if (per === 1) {
        if (this.track) this.track.style.transform = '';
        const card = this.cards[this.page];
        if (card && this.viewport) {
          const delta = card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({
            left: this.viewport.scrollLeft + delta,
            behavior: animate && !this.reduced() ? 'smooth' : 'auto'
          });
        }
      } else if (this.track) {
        const card = this.cards[this.page * per];
        const x = card ? card.offsetLeft : 0;
        this.track.style.transition = animate && !this.reduced() ? '' : 'none';
        this.track.style.transform = `translate3d(${-x}px, 0, 0)`;
      }
      this.writeStatus();
    }

    writeStatus() {
      const per = this.perView();
      const start = this.page * per + 1;
      const end = Math.min(this.cards.length, start + per - 1);
      if (this.statusShort) this.statusShort.textContent = `${start}–${end}`;
      if (!this.statusFull) return;
      const label = this.statusFull.dataset.statusLabel || '';
      this.statusFull.textContent = label
        .replace('__START__', String(start))
        .replace('__END__', String(end));
    }
  }

  customElements.define('aw-mat-band', AwMatBand);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-trust-magazine"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw-trust-rail')) {
  class AwTrustRail extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.statusFull = this.querySelector('[data-status-full]');
      this.statusShort = this.querySelector('[data-status-short]');
      this.page = 0;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.onPrev = () => this.step(-1);
      this.onNext = () => this.step(1);
      this.onResize = () => {
        const total = this.pages();
        if (this.page > total - 1) this.page = total - 1;
        this.apply(false);
      };
      this.onScroll = () => this.syncFromScroll();
      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      window.addEventListener('resize', this.onResize);
      this.viewport?.addEventListener('scroll', this.onScroll, { passive: true });
      this.reveal();
      this.apply(false);
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      window.removeEventListener('resize', this.onResize);
      this.viewport?.removeEventListener('scroll', this.onScroll);
    }

    reduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    perView() {
      return window.matchMedia('(min-width: 990px)').matches ? 3 : 1;
    }

    pages() {
      return Math.max(1, Math.ceil(this.cards.length / this.perView()));
    }

    reveal() {
      const show = () => {
        this.classList.add('is-in');
        this.countUp();
      };
      this.addEventListener('animationend', (event) => {
        if (event.target.classList?.contains('aw-trust__card')) {
          event.target.classList.add('is-settled');
        }
      });
      if (this.reduced() || (window.Shopify && Shopify.designMode)) {
        this.cards.forEach((card) => card.classList.add('is-settled'));
        show();
        return;
      }
      if (!('IntersectionObserver' in window)) {
        show();
        return;
      }
      this.classList.add('is-armed');
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          show();
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      observer.observe(this);
    }

    countUp(to) {
      const el = this.querySelector('[data-count]');
      if (!el) return;
      const target = Number(to != null ? to : el.dataset.count);
      const narrow = window.matchMedia('(max-width: 989px)').matches;
      if (!target) return;
      if (this.reduced() || narrow) {
        el.textContent = target.toLocaleString('en-US');
        return;
      }
      const start = performance.now();
      const duration = 900;
      const tick = (now) => {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toLocaleString('en-US');
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);

      const api = el.getAttribute('data-autivex-api');
      if (!api || el.getAttribute('data-ax-synced')) return;
      el.setAttribute('data-ax-synced', '1');
      fetch(api, { credentials: 'omit' })
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          const live = Number(
            (data && data.business && data.business.reviewCount) ||
            (data && data.aggregateRating && data.aggregateRating.reviewCount) ||
            (data && data.pagination && data.pagination.total) ||
            0
          );
          if (!live || live === target) return;
          el.dataset.count = String(live);
          this.countUp(live);
        })
        .catch(() => {});
    }

    step(direction) {
      const total = this.pages();
      this.page = (this.page + direction + total) % total;
      this.apply(true);
    }

    syncFromScroll() {
      if (this.perView() !== 1 || !this.viewport) return;
      const left = this.viewport.scrollLeft;
      let nearest = 0;
      let best = Infinity;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - left);
        if (distance < best) {
          best = distance;
          nearest = index;
        }
      });
      if (nearest !== this.page) {
        this.page = nearest;
        this.writeStatus();
      }
    }

    apply(animate) {
      const per = this.perView();
      if (per === 1) {
        if (this.track) this.track.style.transform = '';
        if (!animate && this.page === 0) {
          this.writeStatus();
          return;
        }
        const card = this.cards[this.page];
        if (card && this.viewport) {
          const delta = card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({
            left: this.viewport.scrollLeft + delta,
            behavior: animate && !this.reduced() ? 'smooth' : 'auto'
          });
        }
      } else if (this.track) {
        const card = this.cards[this.page * per];
        const x = card ? card.offsetLeft : 0;
        this.track.style.transition = animate && !this.reduced() ? '' : 'none';
        this.track.style.transform = `translate3d(${-x}px, 0, 0)`;
      }
      this.writeStatus();
    }

    writeStatus() {
      const per = this.perView();
      const start = this.page * per + 1;
      const end = Math.min(this.cards.length, start + per - 1);
      if (this.statusShort) this.statusShort.textContent = `${start}–${end}`;
      if (!this.statusFull) return;
      const label = this.statusFull.dataset.statusLabel || '';
      this.statusFull.textContent = label
        .replace('__START__', String(start))
        .replace('__END__', String(end));
    }
  }

  customElements.define('aw-trust-rail', AwTrustRail);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
